import React from "react";
import "./style.css";

const Footer = () => {
  return (
    <React.Fragment>
        <footer style={{marginTop: "400px"}}>
            <div class="container">
                <div class="row">
                    <p id="rights">© 2022 - Violie S. Edrosolan, CPA, Inc.</p>
                </div>

            </div>
        </footer>
    </React.Fragment>
  );
};

export default Footer;